export default __webpack_public_path__ + "static/media/createyourown-icon.dec18e21ad5fc10ff9b6034767a370e2.svg";